import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { spacesClient } from '#pplx_generated/typespec/rest/spaces/client.js';
export const listAtMentionSpaces = async ({ reason, }) => {
    const { data, error, response } = await spacesClient.GET('/rest/spaces/mentions', reason, {
        timeoutMs: getQueryTimeoutMs(),
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to list at mention spaces',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=listAtMentionSpaces.js.map